module.exports = __webpack_public_path__ + "media/img/illustrations/icons/mail-button-768379549935d1f99ccd7cc0bcfc003f.svg";